import type { IconName } from "@similarweb/icons";

import {
    MCP_CHAT_GPT_DESCRIPTION,
    MCP_CHAT_GPT_TITLE,
    MCP_CLAUDE_DESCRIPTION,
    MCP_CLAUDE_TITLE,
    MCP_COPILOT_DESCRIPTION,
    MCP_COPILOT_TITLE,
    MCP_CURSOR_DESCRIPTION,
    MCP_CURSOR_TITLE,
    MCP_MANUS_DESCRIPTION,
    MCP_MANUS_TITLE,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import { colorsPalettes } from "@similarweb/styles";

interface IMCPConnectionItem {
    dataAutomation: string;
    iconName: IconName;
    iconColor?: string;
    titleKey: string;
    descriptionKey: string;
    trackingName: string;
    connectionLink: string;
    tutorialLink?: string;
}

export const MCP_CONNECTIONS: IMCPConnectionItem[] = [
    {
        dataAutomation: "mcp-claude-card",
        iconName: "claude-colored",
        titleKey: MCP_CLAUDE_TITLE,
        descriptionKey: MCP_CLAUDE_DESCRIPTION,
        trackingName: "Claude",
        connectionLink: "https://claude.ai/directory/connectors/similarweb",
        tutorialLink: "https://docs.similarweb.com/api-v5/similarweb-mcp/available-integrations/claude-integration",
    },
    {
        dataAutomation: "mcp-cursor-card",
        iconName: "cursor-black",
        titleKey: MCP_CURSOR_TITLE,
        descriptionKey: MCP_CURSOR_DESCRIPTION,
        trackingName: "Cursor",
        connectionLink: "https://docs.similarweb.com/api-v5/similarweb-mcp/available-integrations/cursor-integration",
    },
    {
        dataAutomation: "mcp-copilot-card",
        iconName: "copilot-colored",
        titleKey: MCP_COPILOT_TITLE,
        descriptionKey: MCP_COPILOT_DESCRIPTION,
        trackingName: "Copilot",
        connectionLink:
            "https://docs.similarweb.com/api-v5/similarweb-mcp/available-integrations/microsoft-copilot-integration",
    },
    {
        dataAutomation: "mcp-chatgpt-card",
        iconName: "chat-gpt-new",
        iconColor: colorsPalettes.black["0"],
        titleKey: MCP_CHAT_GPT_TITLE,
        descriptionKey: MCP_CHAT_GPT_DESCRIPTION,
        trackingName: "ChatGPT",
        connectionLink: "https://chatgpt.com/apps/similarweb/asdk_app_695cdd7e863c819192b88beffc2033b6",
    },
    {
        dataAutomation: "mcp-manus-card",
        iconName: "manus",
        titleKey: MCP_MANUS_TITLE,
        descriptionKey: MCP_MANUS_DESCRIPTION,
        trackingName: "Manus",
        connectionLink: "https://docs.similarweb.com/api-v5/similarweb-mcp/available-integrations/manus-integration",
    },
];
